'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavbarIcon = exports.Navbar = exports.DrillDownTitle = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  display: inline-block;\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  line-height: ', 'px;\n  line-height: ', 'px;\n  padding: ', ';\n  text-decoration: none;\n  ', '\n  ', '\n  color: ', ';\n  font-size: ', 'px;\n\n  & h2 {\n    opacity: ', ';\n    ', ';\n  }\n'], ['\n  line-height: ', 'px;\n  line-height: ', 'px;\n  padding: ', ';\n  text-decoration: none;\n  ', '\n  ', '\n  color: ', ';\n  font-size: ', 'px;\n\n  & h2 {\n    opacity: ', ';\n    ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background: none;\n  border: 0;\n  color: ', ';\n  cursor: pointer;\n  line-height: ', 'px;\n  line-height: ', 'px;\n  margin-right: 16px;\n  opacity: ', ';\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n'], ['\n  background: none;\n  border: 0;\n  color: ', ';\n  cursor: pointer;\n  line-height: ', 'px;\n  line-height: ', 'px;\n  margin-right: 16px;\n  opacity: ', ';\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DrillDownTitle = exports.DrillDownTitle = _styledComponents2.default.section(_templateObject, (0, _helpers.boolStyle)('drillDownEllipsis', 'width:20%'), (0, _helpers.boolStyle)('drillDownEllipsis', 'white-space:nowrap'), (0, _helpers.boolStyle)('drillDownEllipsis', 'overflow:hidden'), (0, _helpers.boolStyle)('drillDownEllipsis', 'text-overflow: ellipsis'));

DrillDownTitle.displayName = 'DrillDownTitle';
var Navbar = exports.Navbar = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.header ? 40 : 14;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.header || props.noPadding ? '0' : '24px 0';
}, function (props) {
  return props.inline ? 'display: inline-block;margin-right: 40px;vertical-align: bottom;' : '';
}, function (props) {
  return props.float ? 'position: absolute; z-index: 2;' : '';
}, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.theme.size[props.size] || props.size;
}, function (props) {
  return props.headerOpacity;
}, function (props) {
  return props.actionOnHeading && '\n      cursor: pointer;\n    ';
});

Navbar.displayName = 'Navbar';
var NavbarIcon = exports.NavbarIcon = _styledComponents2.default.button(_templateObject3, function (props) {
  return props.theme.color[props.variant];
}, function (props) {
  return props.header ? 36 : 14;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});

NavbarIcon.displayName = 'NavbarIcon';
NavbarIcon.defaultProps = {
  arrowVariant: 'base3',
  headerSize: 3,
  headerVariant: 'base3',
  arrowOpacity: 1
};


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-nav-bar/styles.js
// module id = 3021
// module chunks = 4